import GetTicketListDummyData from "../../../dummy/GetTicketListDummyData.json";
import GetTicketDetailDummyData from "../../../dummy/GetTicketDetailDummyData.json";
import SaveTicketDummyData from "../../../dummy/SaveTicketDummyData.json";
import UpdateTicketDummyData from "../../../dummy/UpdateTicketDummyData.json";
import DeleteTicketDummyData from "../../../dummy/DeleteTicketDummyData.json";
import UploadTicketImageDummyData from "../../../dummy/UploadTicketImageDummyData.json";
import DeleteTicketImageDummyData from "../../../dummy/DeleteTicketImageDummyData.json";
import GetTicketStatusDummyData from "../../../dummy/GetTicketStatusDummyData.json";
import GetTicketTrendDummyData from "../../../dummy/GetTicketTrendDummyData.json";
import SuccessResponse from "../dto/common/SuccessResponse";
import TicketListDto from "../dto/ticket/TicketListDto";
import TicketDetailDto from "../dto/ticket/TicketDetailDto";
import TicketSaveRespDto from "../dto/ticket/TicketSaveRespDto";
import TicketImageUploadRespDto from "../dto/ticket/TicketImageUploadRespDto";
import TicketStatusDto from "../dto/ticket/TicketStatusDto";
import TicketTrendDto from "../dto/ticket/TicketTrendDto";

class FakeTicketApi {
    getTicketList = async (): Promise<SuccessResponse<TicketListDto>> => {
        return GetTicketListDummyData;
    };

    getTicketDetail = async (): Promise<SuccessResponse<TicketDetailDto>> => {
        return GetTicketDetailDummyData;
    };

    saveTicket = async (): Promise<SuccessResponse<TicketSaveRespDto>> => {
        return SaveTicketDummyData;
    };

    updateTicket = async (): Promise<SuccessResponse<Record<string, never>>> => {
        return UpdateTicketDummyData;
    };

    deleteTicket = async (): Promise<SuccessResponse<Record<string, never>>> => {
        return DeleteTicketDummyData;
    };

    uploadTicketImage = async (): Promise<SuccessResponse<TicketImageUploadRespDto>> => {
        return UploadTicketImageDummyData;
    };

    deleteTicketImage = async (): Promise<SuccessResponse<Record<string, never>>> => {
        return DeleteTicketImageDummyData;
    };

    getTicketStatus = async (): Promise<SuccessResponse<TicketStatusDto>> => {
        return GetTicketStatusDummyData;
    };

    getTicketTrend = async (): Promise<SuccessResponse<TicketTrendDto[]>> => {
        return GetTicketTrendDummyData;
    };
}

export default FakeTicketApi;
